<template>
  <div v-if="!lazyRender||inited" v-show="active">
    <slot />
  </div>
</template>
<script type="es6">
export default {
  name: 'TabPane',
  data () {
    return {
      inited: false,
      slotLabel: null
    };
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    lazyRender: {
      type: Boolean,
      default: true
    }
  },
  inject: ['rootTabs'],
  components: {
  },
  computed: {
    active () {
      let b = false;
      if (this.rootTabs.currentName === this.name) {
        b = true;
      }
      return b;
    }
  },
  methods: {},
  mounted () {

  },
  watch: {
    active (val) {
      if (val) {
        this.inited = true;
      }
    }
  }
};
</script>
<style lang="scss"></style>
